import { fetchWithAuth } from '@shared/utils/auth';
import { backendUrl } from '@shared/constants/urls/appUrls';

//------------------------------------------------------------------------------
//              Получить тарифы CryptoCloud
//------------------------------------------------------------------------------
export const getCryptoCloudTariffs = async () => {
  const url = `${backendUrl}/api/payments/cryptocloud/tariffs/`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(
        `Сетевая ошибка при получении тарифов CryptoCloud: HTTP error! Status: ${response.status}`
      );
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка получения тарифов CryptoCloud:', error);
    throw error;
  }
};
